import type { Wine } from '../types'

export function checkRapidClicks(
  timestamps: number[],
  threshold: number = 5,
  windowMs: number = 2000,
): boolean {
  const now = Date.now()
  // Remove clicks outside the time window
  while (timestamps.length > 0 && now - timestamps[0] >= windowMs) {
    timestamps.shift()
  }
  timestamps.push(now)
  if (timestamps.length >= threshold) {
    timestamps.length = 0
    return true
  }
  return false
}

export const TASTER_NAMES = [
  'Delk',
  'Jackie',
  'Espen',
  'Diane',
  'Julie',
  'Carol',
  'Guy',
  'Sara',
  'Michelle',
  'Ben',
  'Jim',
  'Jeff',
  'Rick',
]

export const MOCK_WINES = [
  { winery: 'Château Margaux', name: 'Grand Vin', year: 2018 },
  { winery: 'Opus One', name: 'Napa Valley Red', year: 2019 },
  { winery: 'Penfolds', name: 'Bin 389', year: 2020 },
  { winery: 'Ridge', name: 'Monte Bello', year: 2017 },
  { winery: 'Caymus', name: 'Special Selection', year: 2019 },
  { winery: 'Silver Oak', name: 'Alexander Valley', year: 2018 },
  { winery: 'Stag\'s Leap', name: 'Artemis', year: 2020 },
  { winery: 'Duckhorn', name: 'Three Palms', year: 2019 },
  { winery: 'Jordan', name: 'Cabernet Sauvignon', year: 2018 },
  { winery: 'Beringer', name: 'Private Reserve', year: 2017 },
]

export const MOCK_THEMES = [
  'California Cabernets',
  'Napa Valley Showdown',
  'Bordeaux Blends',
  'Summer Reds',
  'Bold & Beautiful',
]

export function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  return shuffled
}

export function generateMockWines(count: number = 6): Omit<Wine, '_key'>[] {
  const shuffled = shuffleArray(MOCK_WINES)
  return shuffled.slice(0, count).map((wine) => ({
    name: `${wine.winery} ${wine.name} ${wine.year}`,
    price: Math.floor(Math.random() * 66) + 20, // 20-85 range
  }))
}

export function generateMockTheme(): string {
  return MOCK_THEMES[Math.floor(Math.random() * MOCK_THEMES.length)]
}
